let page,app,self;

export default {
    data() {
        return {
            pullRefreshLoading: false,
            scrollTo:0
        }
    },
    mounted() {
        console.log("VanPullRefresh mounted");       
        page = this.$route.meta.page;
        app = page.app;
        self = this;       
        page.on(page.paegEvents.pullRefresh,(action)=>{
            if(action == "done") self.$data.pullRefreshLoading = false; 
        });
    },
    activated(){
        setTimeout(()=>{
            window.scrollTo(0,self.$data.scrollTo);
        },200);        
    },
    deactivated(){
        this.$data.scrollTo = window.scrollY;
        window.scrollTo(0,0);
    },
    beforeDestroy() {
        console.log("VanPullRefresh beforeDestroy");               
        page.off(page.paegEvents.pullRefresh);
    },
    methods: {
        onRefresh(){
            let page = this.$route.meta.page,self = this;                                  
            page.trigger(page.paegEvents.pullRefresh,"doing");
            setTimeout(()=>{                
                page.trigger(page.paegEvents.pullRefresh,"done");
            },2000)
        },
    }  
}